import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMathGreaterThanCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"math-greater-than-circle, >"} maskId="square-filled-radius-0-stroke-1-IconMathGreaterThanCircle"><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8.77639 7.82918L17.118 12L8.77639 16.1708L8.32918 15.2764L14.882 12L8.32918 8.72361L8.77639 7.82918Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMathGreaterThanCircle;
